<template>
  <modal :modal-key="'maintenance_modal'"
         :class-style="'modal--welcomeback modal--zero-balance modal--purchase modal--maintenance'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_game_maintenance_title }}</h1>
      <img class="usericon" src="static/images/tools.png" alt="">
    </template>
    <template slot="body">
      <p>{{ getTranslations.home_modals_game_maintenance_description_1 }}<br>{{
        getTranslations.home_modals_game_maintenance_description_2 }}</p>
    </template>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';

export default {
  name: 'game-maintenance',
  components: {
    Modal,
  },
  beforeDestroy() {
    window.location.reload();
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/shared/Maintenance.vue